module.exports = __webpack_public_path__ + "img/arrow.3a4bca93.svg";